import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProject } from '../../../actions/projectActions';
import { formatStartEndTimesToDP } from '../utils/eventUtil';
import { updateDaypilotMilestonesPhasesDates } from '../utils/schedulerUtil';
import { updateBookingSelection } from '../../../actions/schedulerActions';
import { getProjectsMap } from '../../../selectors/project';

export const useProjectDates = (schedulerRef, onClose) => {
    const dispatch = useDispatch();
    const projectsMap = useSelector(getProjectsMap);
    const updateProjectDates = useCallback(
        requestValues => {
            const project = projectsMap[requestValues.project._id];
            dispatch(
                updateProject.request(requestValues.project._id, requestValues, () => {
                    // fix: https://hubplanner.atlassian.net/browse/HUB-8197
                    const projectValues = {
                        backgroundColor: project.color,
                        start: `${requestValues.project.start}T00:00:00.000Z`,
                        end: `${requestValues.project.end}T00:00:00.000Z`,
                        _id: requestValues.project._id,
                        projectId: requestValues.project._id,
                    };
                    const formattedStartEndToDP = formatStartEndTimesToDP([projectValues]);
                    updateDaypilotMilestonesPhasesDates(formattedStartEndToDP, schedulerRef.current.control);
                    onClose && onClose();
                    schedulerRef.current.control.clearSelection();
                    dispatch(updateBookingSelection.request());
                })
            );
        },
        [dispatch, onClose, projectsMap, schedulerRef]
    );

    return { updateProjectDates };
};
